<template lang="jade">
  div.Pricing
    header.Pricing__header
      h3.Pricing__heading {{ fdata.label }}
    div.Pricing__body
      div.Pricing__option(v-for="opt in options"
                          @click="setValue($index)"
                          v-bind:class="{'Pricing__option--active': activeColumn === $index}")
        div.Pricing__item {{ opt.label }}
        div.Pricing__item
          span(style="width: 100%; display: block") {{ opt.price }}
          small(style="width: 100%; font-size: 13px; color: #3a3a3a") per adult per month
        div.Pricing__item
          div.Checked
            input.Checked__input(type="radio"
                                ":value"="opt.value"
                                v-model="formInput"
                                ":name"="field.field"
                                @change="activeColumn = $index")
            label.Checked__control

</template>

<script>
import _ from 'lodash'
import {workflow} from 'src/vuex/getters'
import {url_params} from 'src/utils/util'

export default {
  data  () {
    return {
      formInput: '',
      activeColumn: false,
      uid: this.$parent.uid
    }
  },
  props: {
    fdata: {
      type: Object,
      required: true
    }
  },
  vuex: {
    getters: {
      workflow
    }
  },
  computed: {
    columns () {
      let opts = this.fdata.content[0].options
      return opts.map(x => x.label)
    },
    rows () {
      let inputs = this.fdata.content[0].options
      let prices = this.fdata.content[1].value.split(' ')
      return [prices, inputs]
    },
    field () {
      return this.fdata.content[0]
    },
    prices () {
      return this.fdata.content[1].value.trim().split(' ')
    },
    options () {
      let {options} = this.fdata.content[0]
      window.prices = _.zipObject(_.map(options, xs => xs.value), this.prices)
      return options.map((xs, idx) => _.set(xs, 'price', this.prices[idx]))
    }
  },
  methods: {
    setValue (idx) {
      this.$set('activeColumn', idx)
      let url = location.origin + location.pathname + '?step=one&level='.concat(idx + 2) + location.hash
      if (this.uid) {
        history.replaceState(history.state, null, url)
      }
      this.$set('formInput', this.field.options[idx].value)
      this.$dispatch('fdata::input', {
        [this.field.field]: this.formInput
      })
    },
    reset () {
      this.$set('formInput', '')
      this.$set('activeColumn', false)
    }
  },
  events: {
    'clear': 'reset'
  },
  ready () {
    let params = url_params(location.search)
    if (params.level !== undefined) {
      this.setValue(params.level - 2)
    }

    let field = this.field
    if (field.value) {
      this.setValue(_.findIndex(field.options, ['value', field.value]))
    }
  }
}
</script>



// WEBPACK FOOTER //
// pricing.vue?10f20942